export default __webpack_public_path__ + "83f3d9b46611997fe6bb24a0de88d83c.png";